import { render, staticRenderFns } from "./cateDetail.vue?vue&type=template&id=de793014&scoped=true&"
import script from "./cateDetail.vue?vue&type=script&lang=js&"
export * from "./cateDetail.vue?vue&type=script&lang=js&"
import style0 from "./cateDetail.vue?vue&type=style&index=0&id=de793014&scoped=true&lang=less&"
import style1 from "./cateDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de793014",
  null
  
)

export default component.exports